import { api } from './client'

export const ouraApi = {
  // `platform` (e.g. 'ios') tags the OAuth state so the backend's
  // post-exchange redirect deep-links back into the native shell
  // instead of landing in Safari. Omitted → unchanged web flow.
  authorize: (token, platform) =>
    api.get(platform ? `/oura/authorize?platform=${encodeURIComponent(platform)}` : '/oura/authorize', token),
  callback: (code, state, token) => api.get(`/oura/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state || '')}`, token),
  status: (token) => api.get('/oura/status', token),
  heartbeat: (token) => api.get('/oura/heartbeat', token),
  sync: (token) => api.post('/oura/sync', {}, token),
  today: (token) => api.get('/oura/today', token),
  // Idempotent: drops the token server-side; synced history is kept.
  disconnect: (token) => api.delete('/oura/disconnect', token),
}
